export default {
    roomReservations: [],
    roomReservationsTypes: [],
    roomReservationsStatuses: []
}